// extracted by mini-css-extract-plugin
module.exports = {"information":"style_information__3VFAN","wrapper":"style_wrapper__2x3Df","sub_page":"style_sub_page__3aRFN","sections":"style_sections__H4req"};